/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SurveyReplacementState {
    DRAFT = 'draft',
    FAILED = 'failed',
    SUCCESS = 'success',
    PUBLISHING = 'publishing',
    SCHEDULED = 'scheduled',
}
